import { useQuery } from "@tanstack/react-query";
import { globalSearchApi } from "../../../modules/globalsearch/api";
import { GlobalSearchRequest } from "../../../modules/globalsearch/types";

export const GLOBAL_SEARCH_QUERY_KEYS = {
  searchGlobally: (payload: GlobalSearchRequest) => ["searchGlobally", payload],
};

export const useSearchGlobally = (payload: GlobalSearchRequest) => {
  return useQuery({
    queryKey: GLOBAL_SEARCH_QUERY_KEYS.searchGlobally(payload),
    meta: { globalSpinner: false },
    queryFn: async () => {
      const { data } = await globalSearchApi.searchGlobally(payload);

      return data;
    },
    enabled: payload.keyword.length > 2,
  });
};
